module.exports = __webpack_public_path__ + "static/media/Rubik-Bold.87b4e0d5.ttf";